import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="indicaciones-forms"
export default class extends Controller {
  static targets = ["parenteralForm", "farmacologicaForm", "enteralForm", "nutricionForm"]

  connect() {
    this.currentlyOpen = null
    const collapseElement = this.element.querySelector("#collapseExample")

    if (collapseElement) {
      this.bootstrapCollapse = new bootstrap.Collapse(collapseElement, {
        toggle: false
      })
    } else {
      console.warn("Collapse element not found in indicaciones-forms controller.")
    }
  }

  toggle(event) {
    event.preventDefault()
    const tipo = event.currentTarget.dataset.tipo

    if (this.currentlyOpen === tipo) {
      this.bootstrapCollapse.hide()
      this.#hideAllForms()
      this.currentlyOpen = null
      return
    }

    this.#hideAllForms()

    const targetsMap = {
      parenteral: this.hasParenteralFormTarget && this.parenteralFormTarget,
      farmacologica: this.hasFarmacologicaFormTarget && this.farmacologicaFormTarget,
      enteral: this.hasEnteralFormTarget && this.enteralFormTarget,
      nutricion: this.hasNutricionFormTarget && this.nutricionFormTarget,
    }

    const form = targetsMap[tipo]
    if (form) {
      form.style.display = "block"
    }

    this.bootstrapCollapse.show()
    this.currentlyOpen = tipo
  }

  #hideAllForms() {
    if (this.hasParenteralFormTarget) this.parenteralFormTarget.style.display = "none"
    if (this.hasFarmacologicaFormTarget) this.farmacologicaFormTarget.style.display = "none"
    if (this.hasEnteralFormTarget) this.enteralFormTarget.style.display = "none"
    if (this.hasNutricionFormTarget) this.nutricionFormTarget.style.display = "none"
  }
}
